import request from "utils/request";
import moment from "moment";
import { baseRequestURL } from "api/BaseAPI";
import { AibleClientFactory } from "client/aible/factory";

import { getIsMonitoringDemo } from "containers/Monitoring/reducer";

const demoGlobalData = require("./monitoringDemo_global.json");
const demoUserData = require("./monitoringDemo_user.json");

export function getMonitoring(project) {
  const accountClient = AibleClientFactory.getInstance().getAccountClient();

  return accountClient
    .getCustomerClientFactory(project.account_id)
    .then((factory) => factory.getMetaClient().getMonitorResults(project.id))
    .then((results) => {
      if (results.status == "COMPLETED") {
        return results;
      } else {
        // TODO: ERROR HANDLING
        return {
          status: results.status,
          global: [],
          user: []
        };
      }
    })
    .catch((e) => {
      console.log(e);
      return {
        status: "ERROR",
        global: [],
        user: []
      };
    });
}

export function getMonitoringDemo(project, { segments, users, fields } = {}) {
  if (!getIsMonitoringDemo()) {
    return Promise.resolve({
      status: "ERROR",
      global: [],
      user: []
    });
  }

  // global and user
  // Replace tenant_id, project_id, project_segment_id
  // Set start_date, end_date to be relative to current time
  // Replace Column: "Ethnicity"
  // Replace Column Values: ["Hispanic", "White", "Black", "Other"]
  // Replace created_by to be first user in users

  // user only
  // if !users.length set to []
  // set "user" with "id" === 1 to be users[0]
  // set "user" with "id" === 2 to be users[1 % users.length]
  // set "user" in the data key also

  const DEMO_SEGMENTS = [
    {
      id: 2326,
      column: "Ethnicity",
      value: "White"
    },
    {
      id: 2327,
      column: "Ethnicity",
      value: "Hispanic"
    },
    {
      id: 2328,
      column: "Ethnicity",
      value: "Black"
    },
    {
      id: 2329,
      column: "Ethnicity",
      value: "Other"
    }
  ];
  const DEMO_FIELDS = [
    {
      label: "Region",
      values: ["East", "West", "Central"]
    },
    {
      label: "Campaign_Name",
      values: ["Campaign A", "Campaign B", "Campaign C", "Campaign D", "Campaign E"]
    }
  ];
  const DEMO_USERS = [
    {
      id: 1,
      fullname: "Aible Demo"
    },
    {
      id: 2,
      fullname: "Customer Success"
    }
  ];
  // const DEMO_SEGMENT_IDS = [2326, 2327, 2328, 2329]
  // const DEMO_COLUMN = "Ethnicity"
  // const DEMO_COLUMN_VALUES = ["White", "Hispanic" , "Black" , "Other"]
  // const DEMO_USER_IDS = [1, 2]
  const DEMO_LATEST_DATE = "2023-12-10T00:00:00";

  const tenantId = project?.tenant_id;
  const projectId = project?.id;
  const currentMoment = moment().startOf("day").subtract(5, "days");
  const demoLatestMoment = moment(DEMO_LATEST_DATE);

  const convertDate = (cTime) => {
    const cMoment = moment(cTime);
    const dayDifference = demoLatestMoment.diff(cMoment, "days");
    return moment(currentMoment).subtract(dayDifference, "days").format();
  };

  const convertMonitorData = (rawData) => {
    const retData = {
      tenant_id: tenantId,
      id: rawData?.id,
      project_id: projectId,
      deleted: rawData?.deleted
    };

    const segmentIndex = DEMO_SEGMENTS.findIndex((s) => s?.id === rawData?.project_segment_id);
    const demoSegment = DEMO_SEGMENTS[segmentIndex];

    if (segmentIndex > segments?.length - 1 || !demoSegment) {
      return;
    }

    const currSegment = segments[segmentIndex];

    retData.project_segment_id = currSegment?.id;

    const segmentData = {
      ...rawData?.data,
      monitor_results: {
        [currSegment?.column]: {
          [currSegment?.value]: rawData?.data?.monitor_results?.[demoSegment.column]?.[demoSegment.value]
        }
      }
    };

    if (fields) {
      DEMO_FIELDS.forEach((dField, i) => {
        if (i < fields?.length) {
          const cField = fields[i];
          segmentData.monitor_results[cField.label] = {};
          dField.values.forEach((dValue, vIndex) => {
            if (vIndex < cField?.values?.length) {
              const cValue = cField?.values?.[vIndex];
              segmentData.monitor_results[cField.label][cValue] =
                rawData?.data?.monitor_results?.[dField.label]?.[dValue];
            }
          });
        }
      });
    }

    if (rawData.user) {
      const userIndex = DEMO_USERS.findIndex((u) => u?.id === rawData.user.id);
      const currUser = users?.[userIndex % users?.length] || rawData.user;

      retData.user = currUser;
      segmentData.user = currUser?.id;
    }

    retData.data = segmentData;

    const startDate = convertDate(rawData?.start_date);
    const endDate = convertDate(rawData?.end_date);

    retData.start_date = startDate;
    retData.end_date = endDate;
    retData.created_date = startDate;
    retData.updated_date = endDate;

    if (users?.[0]) {
      retData.created_by = {
        id: users[0]?.id,
        fullname: users[0]?.fullname
      };
    } else {
      retData.created_by = rawData.created_by;
    }

    return retData;
  };

  const rawGlobalData = demoGlobalData || [];
  const rawUserData = demoUserData || [];

  const globalData = rawGlobalData
    .map((d) => {
      return convertMonitorData(d);
    })
    .filter((d) => Boolean(d));
  const userData = rawUserData
    .map((d) => {
      return convertMonitorData(d);
    })
    .filter((d) => Boolean(d));

  const response = {
    status: "COMPLETED",
    global: globalData,
    user: userData
  };

  return Promise.resolve(response);
}

export function getUserMonitoring(projectId) {
  if (isNaN(projectId)) {
    return Promise.resolve();
  }
  return request(baseRequestURL + "v1/project_segment_user_monitors?project_id=" + projectId);
}

export function getMonitoringData() {
  return request(baseRequestURL + "v1/project_segment_monitors/", {
    method: "GET"
  }).then((response) => {
    return response;
  });
}
